import { render, staticRenderFns } from "./SchoolForm.vue?vue&type=template&id=19dfafe0&scoped=true"
import script from "./SchoolForm.vue?vue&type=script&lang=js"
export * from "./SchoolForm.vue?vue&type=script&lang=js"
import style0 from "./SchoolForm.vue?vue&type=style&index=0&id=19dfafe0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dfafe0",
  null
  
)

export default component.exports